export class GenericListInputDefinition {
  data: any;
  type: 'text' | 'number' | 'time';
  controlName: any;
  suffix: string;

  constructor(data: any, type: 'text' | 'number' | 'time', controlName: any, suffix?: any) {
    this.data = data;
    this.type = type;
    this.controlName = controlName;
    this.suffix = suffix;
  }
}
